import { cn } from "../../../../helpers/utils";

const SwitchThumb = ({ checked }) => {
  return (
    <div
      className={cn(
        "absolute left-1 top-1/12 h-6 w-6 rounded-full transition-transform duration-200 ease-out",
        checked
          ? "translate-x-5 bg-green-500"
          : "translate-x-0 bg-white border border-gray-300"
      )}
    />
  );
};

export default SwitchThumb;
